import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get, capitalize } from 'lodash';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { bindActionCreators } from 'redux';
import { PortalConfigContext } from '../../config/portal';
import { generateBlogPath } from '../../utils/urlHelpers/blog';
import messages from '../../utils/translationMessages';
import './styles.css';

class HomeBlogSection extends PureComponent {

  getArticleURL = (article) => generateBlogPath({}, {article: article.name});

  getArticleFeaturedImageURL = (article) => {
    const baseURL = get(article.content, 'featuredImage', '');
    const parsedURL = baseURL.replace('{{baseUrl}}',article.blogUrl);

    return parsedURL;
  }

  toTitleCase(string) {
    return string.split(' ').map((word) => {
      return (capitalize(word));
    }).join(' ');
  }

  render() {
    const {
      blogSection: { records },
      intl: { formatMessage: t }
    } = this.props;
    const articles = [...records];
    const mainArticle = articles.shift();
    const mainArticleCategory = mainArticle.categories[0];
    const context = get(this, 'context', {});
    const portal = get(context, 'fullName', undefined);

    return (
      <div className="home-blog-section">
        <div className="blog-section-title">
          {t(messages.homeBlogSection.title)
            .replace('{portal}', portal)}
        </div>
        <div className="home-articles-container">
          <div className="home-main-article">
            <a href={this.getArticleURL(mainArticle)}>
              <img src={this.getArticleFeaturedImageURL(mainArticle)} className="article-picture" alt={mainArticle.title} />
              <div className="article-text-container">
                <div className="article-title">{mainArticle.title}</div>
                <div className="article-category">{this.toTitleCase(t(messages.blog.categories[mainArticleCategory]))}</div>
              </div>
            </a>
          </div>
          <div className="home-secondary-articles">
            {articles.map((article) => {
              const category = article.categories[0];
              return (
                <a href={this.getArticleURL(article)} key={article.id}>
                  <div className="home-article">
                    <img src={this.getArticleFeaturedImageURL(article)} className="article-picture" alt={article.title} />
                    <div className="article-text-container">
                      <div className="article-title">{article.title}</div>
                      <div className="article-category">{category ? this.toTitleCase(t(messages.blog.categories[category])) : ''}</div>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
        <div className="blog-section-read-more">
          <a href={generateBlogPath({},{})} >
            {t(messages.homeBlogSection.readMore)
              .replace('{portal}', portal)}
          </a>
        </div>
      </div>
    );
  }
}

HomeBlogSection.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  blogSection: PropTypes.shape({
    count: PropTypes.number.isRequired,
    records: PropTypes.array.isRequired,
  })
};

HomeBlogSection.contextType = PortalConfigContext;

export default connect(
  null,
  (dispatch) => bindActionCreators({}, dispatch)
)(injectIntl(HomeBlogSection));
